export default "__VITE_ASSET__BGa0ALCX__"